import React from 'react';
import classnames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import { RemotasksUITheme } from 'design-system/theme';

interface TypographyProps {
  className?: string;
  medium?: boolean;
  mono?: boolean;
  children?: React.ReactNode;
}

const useStyles = makeStyles((theme: RemotasksUITheme) => ({
  h1: {
    fontSize: '24px',
    lineHeight: '32px',
    fontWeight: 500,
  },
  h2: {
    fontSize: '20px',
    lineHeight: '28px',
    fontWeight: 500,
  },
  h3: {
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 500,
  },
  text: {
    fontSize: '14px',
    lineHeight: '20px',
    textTransform: 'none',
    fontWeight: 400,
  },
  caption: {
    fontSize: '11px',
    lineHeight: '16px',
    letterSpacing: '0.1px',
  },
  medium: {
    fontWeight: 500,
  },
  mono: {
    fontFamily: theme.typography.fontFamilyMono,
    lineHeight: '1em',
  },
}));

/*
 * Heading Text
 */

type SpanProps = React.HTMLProps<HTMLSpanElement>;

const H1: React.FC<SpanProps> = ({ className, ...props }) => {
  const classes = useStyles();
  return <span className={classnames(className, classes.h1)} {...props} />;
};

const H2: React.FC<SpanProps> = ({ className, ...props }) => {
  const classes = useStyles();
  return <span className={classnames(className, classes.h2)} {...props} />;
};

const H3: React.FC<SpanProps> = ({ className, ...props }) => {
  const classes = useStyles();
  return <span className={classnames(className, classes.h3)} {...props} />;
};

/*
 * Body Text
 */

const Text: React.FC<TypographyProps> = props => {
  const classes = useStyles();
  return (
    <span
      className={classnames(props.className, classes.text, {
        [classes.medium]: props.medium,
        [classes.mono]: props.mono,
      })}
    >
      {props.children}
    </span>
  );
};

/* ---------------------------------------- */

const Caption: React.FC<TypographyProps> = props => {
  const classes = useStyles();
  return (
    <span
      className={classnames(props.className, classes.caption, {
        [classes.medium]: props.medium,
        [classes.mono]: props.mono,
      })}
    >
      {props.children}
    </span>
  );
};

export { H1, H2, H3, Text, Caption };
